<button
  class="button"
  [ngClass]="getClassName()"
  [ngStyle]="getButtonStyles()"
  [disabled]="isDisabled"
  (click)="buttonOnClick()"
>
  <span *ngIf="iconLeft !== ''" class="icon-rounded-background">
    <app-icon
      [ngClass]="iconClass"
      name="{{ iconLeft }}"
      color="{{ iconColor }}"
      size="{{ iconSize }}"
      (iconClicked)="handleLeftIconClick()"
    ></app-icon>
  </span>
  <span class="button-text">
    <app-text [textStyleType]="textStyleClass" class="button-regular">{{
      text
    }}</app-text>
  </span>
  <span *ngIf="iconRight !== ''">
    <app-icon
      [ngClass]="iconClass"
      name="{{ iconRight }}"
      color="{{ iconColor }}"
      size="{{ iconSize }}"  
      (iconClicked)="handleRightIconClick()"
    ></app-icon>
  </span>
</button>
